var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-stories-article-illustrated-main-copy-paragraph",class:[
        { 'c-stories-article-illustrated-main-copy-paragraph--last': _vm.isLast },
        ("c-stories-article-illustrated-main-copy-paragraph--" + _vm.indexParagraph)
    ]},[_c('div',{staticClass:"c-stories-article-illustrated-main-copy-paragraph__copy | t-cms",domProps:{"innerHTML":_vm._s(_vm.paragraph.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }